import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Streak } from "../common/Streak";

const styles = {
  name: {
    fontSize: "22px",
    color: "rgb(70, 130, 180)",
    textTransform: "uppercase",
  },
  value: {
    fontSize: "22px",
    color: "rgb(228, 229, 242)",
    textTransform: "uppercase",
    minWidth: "45",
    width: "60px",
  },
  helpIcon: {
    fontSize: "13px",
    color: "rgb(70, 130, 180)",
    border: "1px solid rgb(70, 130, 180)",
    borderRadius: "50%",
    width: "16px",
    height: "16px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "6px",
    cursor: "help",
    verticalAlign: "middle",
  },
};

const getValue = (value, type) => {
  if (!type) {
    return value;
  } else if (type === "streak") {
    return <Streak length={value.length} type={value.type} />;
  }
};

/**
 * @param {{ name: string, value: any, type?: string, tooltip?: string, extra?: any }} props
 */
export const PlayerLineStat = ({ name, value, type, tooltip, extra }) => {
  return (
    <div className="d-flex">
      <div style={styles.name}>
        {name}
        {tooltip && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{tooltip}</Tooltip>}
          >
            <span style={styles.helpIcon}>?</span>
          </OverlayTrigger>
        )}
      </div>
      <div style={styles.value} className="d-flex justify-content-end">
        {getValue(value, type)}
      </div>
      {extra}
    </div>
  );
};
